export enum ScrollValues {
  defaultPageNum = 1,
  limitNum = 10,
}

export enum ScrollListContainerSize {
  introPage = 202,
  searchResultPage = 286,
}

export enum ToggleType {
  default = 0,
  myPreset = 1,
}

export type SearchRequsetType = "title" | "tag" | "artist";

export type IntroRequsetType = "top50List" | "recentlyUsed" | "artists";

export type CommunityContentType = "PRESET" | "PROFILE";

export type PrivacyType = "PUBLIC" | "PRIVATE";

export type BtnType = "ONESHOT" | "LOOP";
